<template>
	<nav aria-label="Page navigation">
	  <ul class="pagination">
	    <slot></slot>
	  </ul>
	</nav>
</template>

<script>
export default {
	name: 'paginacao'
}
</script>
